<template>
  <div v-if="mode" class="fb-star-rating">
    <comment :element-uuid="element.uuid" :submission-uuid="main_sid" />
    <h5 v-if="saveData.label">{{ saveData.label | token_replace(nid)}}</h5>
    <md-field class="no-line justify-content-center">
      <star-rating
        @current-rating="updateValue"
        v-model="saveData.value"
        :increment="parseInt(saveData.increment)"
        :max-rating="parseInt(saveData.max_rating)"
        :star-size="24"
        :show-rating="false"
        :required="saveData.required === true ? 'required' : null"
        :rounded-corners="true"
        active-color="#ffa300"
        inactive-color="#ffffff"
        :border-width="6"
        border-color="#ffa300"
      ></star-rating>
    </md-field>
    <md-field :class="messageClass" class="no-line justify-content-center">
      <span class="md-helper-text">{{ saveData.help_text | token_replace(nid)}}</span>
      <span class="md-error">*Required.</span>
    </md-field>
  </div>
  <md-card v-else class="md-elevation-2 md-layout-item">
    <fb-controll
      :controll="saveData.label || 'Rating'"
      @collapse-click="collapsePreview"
      @setting-click="showSettings"
      @menu-delete="$emit('menu-delete')"
    />
    <md-content v-show="!collapse">
      <md-field>
        <p>{{ saveData.label | token_replace(nid)}}</p>
        <star-rating
          v-model="tempData.value"
          :increment="parseInt(tempData.increment)"
          :max-rating="parseInt(tempData.max_rating)"
          :star-size="30"
          :show-rating="false"
          :required="tempData.required === true ? 'required' : null"
        ></star-rating>
        <span class="md-helper-text">{{ saveData.help_text | token_replace(nid)}}</span>
      </md-field>
    </md-content>
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>Settings</md-dialog-title>
      <md-dialog-content>
        <md-field>
          <label>Label</label>
          <md-input v-model="tempData.label"></md-input>
        </md-field>
        <md-field class="fb-select">
          <label>Type</label>
          <md-select v-model="tempData.type">
            <md-option value="rate_content">Rate content</md-option>
            <md-option value="other">Other rating</md-option>
          </md-select>
        </md-field>
        <md-field>
          <label>Increment</label>
          <md-input v-model="tempData.increment"></md-input>
        </md-field>
        <md-field>
          <label>Rating</label>
          <md-input v-model="tempData.value"></md-input>
        </md-field>
        <md-field>
          <label>Max Rating</label>
          <md-input v-model="tempData.max_rating"></md-input>
        </md-field>
        <md-field>
          <label>Help Text</label>
          <md-input v-model="tempData.help_text"></md-input>
        </md-field>
        <md-checkbox v-model="tempData.required">Required</md-checkbox>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="cancel">Close</md-button>
        <md-button class="md-primary" @click="save">Save</md-button>
      </md-dialog-actions>
    </md-dialog>
  </md-card>
</template>

<script>
import FbElementMixin from "./FbElementMixin";
import StarRating from "vue-star-rating";

export default {
  name: "FbStarRating",
  props: ["element", "mode", "validate"],
  mixins: [FbElementMixin],

  components: {
    StarRating,
  },

  computed: {
    messageClass() {
      return {
        "md-invalid": !this.valid && this.validate === true,
      };
    },
    valid() {
      if (this.isDraft) {
        return true;
      }
      let val;
      val = !(this.saveData.required === true && this.saveData.value == 0);
      return val;
    },
  },
  created() {
    if (
      this.sid &&
      this.sid != "" &&
      window.drupalSettings.form_builder[this.nid]["submissions"][this.sid][
        this.element.uuid
      ]
    ) {
      this.saveData.value =
        window.drupalSettings.form_builder[this.nid]["submissions"][this.sid][
          this.element.uuid
        ].value;
      this.$emit("set-value", this.value);
    }
    this.$emit("validation", this.valid);
  },
  data() {
    return {
      tempData: {
        label: this.element.data.label || "",
        type: this.element.data.type || "rate_content",
        increment: this.element.data.increment || 1,
        value: this.element.data.value || 0,
        max_rating: this.element.data.max_rating || 5,
        help_text: this.element.data.help_text || "",
        required: this.element.data.required || false,
      },
      saveData: {
        label: this.element.data.label || "",
        type: this.element.data.type || "rate_content",
        value: this.element.data.value || 0,
        increment: this.element.data.increment || 1,
        max_rating: this.element.data.max_rating || 5,
        help_text: this.element.data.help_text || "",
        required: this.element.data.required || false,
      },
    };
  },
  watch: {
    "saveData.rating": function value() {
      this.$emit("validation", this.valid);
      this.$emit("set-value", this.value);
    },
  },
  methods: {
    updateValue(value) {
      this.saveData.value = value;
      this.$emit("validation", this.valid);
      this.$emit("set-value", this.value);
    },
  },
};
</script>
<style lang="scss" scoped>
.fb-star-rating {
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
  p {
    font-size: 16px;
    font-family: $font-filson-soft;
    font-weight: bold;
    margin-bottom: 0px;
    padding-bottom: 0px;
  }
}
</style>
